import React from 'react';
import { Avatar } from 'antd';
import BlankAvatar from '../../../../shared/BlankAvatar';

interface Props {
  routeColors: string[];
}

const NumberOfRoutes: React.FC<Props> = ({ routeColors }) => {
  if (routeColors.length === 0) {
    return <></>;
  }

  const maxRoutes = 20;

  return (
    <Avatar.Group>
      {routeColors.slice(0, maxRoutes).map((color: string) => (
        <Avatar
          size={12}
          key={color}
          style={{
            backgroundColor: color,
            marginLeft: '-4px',
            border: 'none',
          }}
          data-cy="route-color-avatar"
        />
      ))}
      {routeColors.length > maxRoutes && (
        <BlankAvatar
          size={12}
        >
          +
        </BlankAvatar>
      )}
    </Avatar.Group>
  );
};

export default NumberOfRoutes;
